import { Add, Delete } from '@mui/icons-material';
import {
  Autocomplete,
  Card,
  styled,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from '@mui/material';
import React from 'react';

const StyledTable = styled(Table)(() => ({
  '& .MuiTableRow-root:last-child': {
    '& td': {
      borderBottom: 0,
    },
  },
}));

function PersonalizationTable({
  personalizationArray,
  sizeLabel,
  colorLabel,
  addPersonalizationRow,
  deletePersonalizationRow,
  changePersonalizationArray,
  isApplyToAllPersonalizationLines,
}) {
  if (!personalizationArray || personalizationArray?.length === 0) {
    return null;
  }

  const itemsQuantity = personalizationArray.reduce((acc, personalization) => {
    const key = personalization.itemSize || personalization.itemColor;
    const sequance = personalization.sequance;
    if (key && sequance === 1) {
      if (acc[key]) {
        acc[key]++;
      } else {
        acc[key] = 1;
      }
    }
    return acc;
  }, {});
  const lastRowQtyNo = personalizationArray[personalizationArray.length - 1]?.rowQtyNo;
  return (
    <Card variant="outlined">
      <StyledTable>
        <TableHead>
          <TableRow>
            <TableCell>Item</TableCell>
            <TableCell>{sizeLabel}</TableCell>
            <TableCell>Item {colorLabel}</TableCell>
            <TableCell>Line</TableCell>
            <TableCell>Text</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {personalizationArray.map((personalization, key) => {
            let flag = Number(personalization.sequance) === 1;
            const objOptions = [];
            if (!!personalization?.isDrp) {
              !!personalization?.drpValue &&
                personalization?.drpValue.length > 0 &&
                personalization.drpValue.forEach((op) => {
                  objOptions.push({ value: op, label: op });
                });
            }

            if (isApplyToAllPersonalizationLines && personalization.rowQtyNo !== 1) {
              return null;
            }

            return (
              <TableRow key={key}>
                <TableCell>
                  {flag &&
                    (isApplyToAllPersonalizationLines
                      ? `All items ( ${itemsQuantity[personalization.itemSize] ?? lastRowQtyNo} )`
                      : 'Item ' + personalization.rowQtyNo)}
                </TableCell>
                <TableCell>{flag && personalization.itemSize}</TableCell>
                <TableCell>{flag && personalization.itemColor}</TableCell>
                <TableCell>
                  {!!personalization?.lineName
                    ? personalization?.lineName
                    : 'Line ' + personalization.sequance}
                </TableCell>
                <TableCell>
                  {!!!personalization?.isDrp ? (
                    <TextField
                      variant="outlined"
                      size="small"
                      placeholder="Value"
                      fullWidth
                      onChange={(e) => {
                        changePersonalizationArray(e.target.value, 'displayText', personalization);
                      }}
                      value={personalization.displayText}
                    />
                  ) : (
                    <Autocomplete
                      value={
                        objOptions.find((op) => op.value === personalization.displayText) ?? ''
                      }
                      options={objOptions}
                      name="isDrpValuePer"
                      clearOnBlur
                      blurOnSelect
                      size="small"
                      renderInput={(params) => (
                        <TextField {...params} required placeholder="Option" variant="outlined" />
                      )}
                      getOptionLabel={(option) => option?.label ?? ''}
                      onChange={(_, value) => {
                        changePersonalizationArray(
                          value?.value ?? null,
                          'displayText',
                          personalization,
                        );
                      }}
                      onClear={() => {
                        changePersonalizationArray(null, 'displayText', personalization);
                      }}
                    />
                  )}
                </TableCell>
                {!!!personalization?.isDrp &&
                !!!personalization?.isEnabled &&
                !!!personalization?.requiredLine ? (
                  <TableCell>
                    {flag && (
                      <Add
                        onClick={() => {
                          addPersonalizationRow(personalization, key);
                        }}
                      />
                    )}
                    {!flag && (
                      <Delete
                        onClick={() => {
                          deletePersonalizationRow(personalization);
                        }}
                      />
                    )}
                  </TableCell>
                ) : (
                  ''
                )}
              </TableRow>
            );
          })}
        </TableBody>
      </StyledTable>
    </Card>
  );
}

export default PersonalizationTable;
